/**
 * Comparaison de rôles staff (SPEC §4 : admin > guichet > lecture).
 *
 * Deux mécanismes, volontairement distincts :
 *
 *  - `aAuMoinsRole` — hiérarchie par poids. Convient à ce qui est cumulatif :
 *    tout ce qu’un `guichet` peut faire, un `admin` le peut aussi.
 *  - `aRole` (de `@tb/shared`) — liste explicite. C’est celui qu’il faut pour
 *    les écrans dont l’accès n’est PAS hiérarchique : les tableaux de bord sont
 *    ouverts à `lecture` (la direction) et à `admin`, mais pas au `guichet`,
 *    qui n’a rien à faire dans les chiffres de la maison.
 *
 * Le doute doit toujours se trancher vers la liste explicite.
 */

import { POIDS_ROLE, type RoleUtilisateur } from '@tb/shared'

export { aRole } from '@tb/shared'

/** `role` pèse-t-il au moins autant que `minimal` ? */
export function aAuMoinsRole(
  role: RoleUtilisateur | null | undefined,
  minimal: RoleUtilisateur,
): boolean {
  if (role === null || role === undefined) return false
  return POIDS_ROLE[role] >= POIDS_ROLE[minimal]
}
